import React from 'react';
import { Link } from 'react-router-dom';
import { CASE_STUDIES, STATS } from '../constants';

function Work() {
  return (
    <div className="work-page">
      {/* Hero Section */}
      <section className="hero" style={{ padding: '150px 2rem 80px' }}>
        <h1>Our Work</h1>
        <p>Real projects. Real results. Real businesses.</p>
      </section>

      {/* Case Studies */}
      <section>
        <div className="container">
          {CASE_STUDIES.map((study) => (
            <div key={study.id} style={{ marginBottom: '5rem' }}>
              <div className="case-study" style={{ padding: '3rem' }}>
                <div className="case-study-header" style={{ marginBottom: '2rem' }}>
                  <span className="case-study-logo" style={{ fontSize: '4rem' }}>
                    {study.logo}
                  </span>
                  <div className="case-study-info">
                    <h2 style={{ marginBottom: '0.5rem' }}>{study.client}</h2>
                    <p className="case-study-industry" style={{ fontSize: '1.1rem' }}>
                      {study.industry}
                    </p>
                  </div>
                </div>
                
                <div className="grid grid-3" style={{ marginTop: '2.5rem' }}>
                  <div className="case-detail">
                    <strong style={{ fontSize: '1.1rem' }}>The Challenge</strong>
                    <p>{study.challenge}</p>
                  </div>
                  <div className="case-detail">
                    <strong style={{ fontSize: '1.1rem' }}>Our Solution</strong>
                    <p>{study.solution}</p>
                  </div>
                  <div className="case-detail case-result">
                    <strong style={{ fontSize: '1.1rem' }}>The Result</strong>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600 }}>
                      {study.result}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="section-header" style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: 'white' }}>By the Numbers</h2>
        </div>
        <div className="stats-grid">
          {STATS.map((stat, index) => (
            <div key={index} className="stat-item">
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--primary-color)', color: 'white', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ color: 'white' }}>Want Results Like These?</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.2rem', marginBottom: '2rem' }}>
            Let's talk about your project and how we can help.
          </p>
          <Link to="/contact" className="btn" style={{ backgroundColor: 'white', color: 'var(--primary-color)' }}>
            Get Started
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Work;